import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cartService from 'services/CartService'
import { setQueryInUrl } from 'utils'

export default function AddToCartPromoButton({ images, badgeImage, href, products }) {
  const [busy, setBusy] = useState(false)

  const onClickHandler = () => {
    if (busy) return
    setBusy(true)

    cartService
      .addItems(products)
      .then(() => {
        if (!href) return

        const ac = window?._1und1datalayer?.[2]?.campaign?.lasttouchactioncode
        if (ac && ac.length > 5) {
          href = setQueryInUrl(href, { ac })
        }

        location.href = href
      })
      .finally(() => setBusy(false))
  }

  return (
    <div className="tariff-device-promo py-0" data-testid="add-to-cart-promo-button">
      <div className="tariff-device-image" data-hw-option="hw">
        <div>
          <button className="tariff-device-promo__form-button" onClick={onClickHandler}>
            <span className="btn__span">
              <div className="d-flex align-items-center justify-content-center">
                <div className="tariff-device-promo__images tariff-device-promo__images--cut justify-content-center tariff-device-promo__images--wave">
                  {images.map((src, i) => (
                    <div key={i} className="tariff-device-promo__image">
                      <img src={src} data-testid="add-to-cart-promo-button-image" />
                    </div>
                  ))}
                </div>
              </div>
              {badgeImage && (
                <div style={{ position: 'relative', top: '-40px', left: '-50px', marginBottom: '-50px', zIndex: 3 }}>
                  <img
                    className="d-inline-flex pr-1 mt-n2 mb-1"
                    style={{ width: '85px' }}
                    src={badgeImage}
                    data-testid="add-to-cart-promo-button-badge"
                  />
                </div>
              )}
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}

AddToCartPromoButton.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  badgeImage: PropTypes.string,
  href: PropTypes.string,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['article', 'bundle']).isRequired,
      id: PropTypes.string.isRequired,
      amount: PropTypes.number,
      properties: PropTypes.object
    })
  )
}

AddToCartPromoButton.defaultProps = {
  images: [],
  products: []
}
